import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import styles from './safeAndSecureBenefits.module.scss';

export default function SafeAndSecureBenefits({ title = '', items = [] }) {
  return (
    <div className={styles.wrapper}>
      {title && <div className={styles.header}>{title}</div>}
      <div>
        {items &&
          items?.map((item, index) => {
            const key = `key ${index}`;
            return (
              <div key={key} className={styles.itemWrapper}>
                <div className={styles.img}>
                  {item?.icon && (
                    <img
                      src={item?.icon?.path}
                      className={styles.icon}
                      alt={item?.icon?.alt}
                      loading="lazy"
                      data-testid={item?.icon?.path}
                      {...{
                        ...(item?.icon?.width && {
                          width: item?.icon?.width,
                        }),
                        ...(item?.icon?.height && {
                          height: item?.icon?.height,
                        }),
                      }}
                    />
                  )}
                </div>
                <div className={styles.content}>
                  <div className={styles.title} data-testid={item?.title}>
                    {item?.title}
                  </div>
                  <div
                    className={styles.description}
                    data-testid={item?.description}
                  >
                    {parse(`${item?.description}`)}
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}

SafeAndSecureBenefits.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.shape({
        path: PropTypes.string,
        alt: PropTypes.string,
      }),
      title: PropTypes.string,
      description: PropTypes.string,
    })
  ),
};
